var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center space-x-5",attrs:{"id":"nav"}},[_c('Timeframe'),_c('NewsSource')],1)}
var staticRenderFns = []

export { render, staticRenderFns }